import ClipboardJS from "clipboard";

export default class CopyLink {
	constructor() {
		this.init();
	}

	init() {
		new ClipboardJS( '[data-copy-link]', {
			text: function( trigger ) {
				return trigger.getAttribute('data-copy-link');
			}
		} );
	}
}
